import React from "react";
import { connect } from "react-redux";
import { Popconfirm, message } from "antd";
import _ from "lodash";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import fontawesome from '@fortawesome/fontawesome';
import { faEye, faTrash } from '@fortawesome/fontawesome-free-solid';
import {Spinner} from "../common/Spinner";

fontawesome.library.add(faEye, faTrash);

//action imports

//component imports

//file imports

class Service extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            activity: this.props.activity,
            activists: this.props.activists,
            activistsLoading: this.props.activistsLoading,
        }
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if (nextProps.activity !== this.props.activity) {
            this.setState({
                activity: nextProps.activity
            });
        }

        if (nextProps.activists !== this.props.activists) {
            this.setState({
                activists: nextProps.activists
            });
        }

        if (nextProps.activistsLoading !== this.props.activistsLoading) {
            this.setState({
                activistsLoading: nextProps.activistsLoading
            });
        }
    }

    onDeleteActivity(activityID) {
        //this.props.deleteCompanyFile(fileID);
    }

    onCancel() {
        message.info("Deletion is canceled").then();
    }

    renderActivity() {
        const { activity } = this.state;

        if (!(_.isEmpty(activity))) {
            return(
                <div className={"activityBox"} key={activity.activityID}>
                    <div>
                        <h4>{activity.activityTitle}</h4>
                        <div><p style={{width: '98%', wordBreak: 'break-all'}}>{activity.activityDescription}</p></div>
                    </div>
                    <Popconfirm
                        title="Are you sure to delete this activity?"
                        onConfirm={() => this.onDeleteActivity(activity.activityID)}
                        onCancel={() => this.onCancel()}
                        okText="Yes"
                        cancelText="No"
                    >
                        <div className={"clickable"} style={{textAlign: 'center', marginTop: 15}}><FontAwesomeIcon icon={"trash"} size={"1x"} className={"trashIcon2"}/></div>
                    </Popconfirm>
                </div>
            );
        } else {
            return <h2>Choose an activity to view</h2>
        }
    }

    renderActivists() {
        const { activists, activistsLoading } = this.state;

        if (activistsLoading) {
            return <Spinner/>
        } else {
            if (activists.length !== 0) {
                return (
                    <div>
                        {
                            activists.map(activist => {
                                return (
                                    <div className={"registersCard"}>
                                        {activist.name}
                                        {activist.phone}
                                    </div>
                                );
                            })
                        }
                    </div>
                )
            } else {
                return <h3>No one has signed up for this activity yet</h3>
            }
        }
    }

    render() {
        return(
            <div className={"newCustomerContainer"}>
                { this.renderActivity() }
                <div className={"registersBox"}>
                    <h2>People Registered</h2>
                    { this.renderActivists() }
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    const { activity, activists, activistsLoading } = state.activities;
    return {
        activity,
        activists,
        activistsLoading
    }
}

export default connect(mapStateToProps, { })(Service);